export default __webpack_public_path__ + "6ae5ddf79589418f43e5dc54d1d1e0ed.svg";